<template>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2">
        <div class="h-dialogImg">
            <div class="h-disTable">
                <div class="h-tableCell">
                    <h1>查看外销预测信息</h1>
                    <p>Modify export forecast information</p>
                </div>
            </div>
        </div>
        <div class="h-formLine" style="width: 950px; margin:0 auto">
            <el-form ref="form"
                     :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                <el-form-item label="区域" class="h-elformWrap-2" required="">
                    <el-select v-model="saveData.area" filterable class="h-tableInput" disabled="">
                        <el-option v-for="(item,index) in areaList" :key="index" :label="item.qyname" :value="item.qycode" >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="国家名称" class="h-elformWrap-2" required="">
                    <el-select v-model="saveData.country" filterable class="h-tableInput" @change="clickmodel1" disabled="">
                        <el-option v-for="(item,index) in gjCo" :key="index" :label="item" :value="item" >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品编码" class="h-elformWrap-2" required="">
                    <el-select class="h-tableInput" filterable v-model="saveData.productCode"  disabled="" :filter-method="dataFilter" @change="selectCode(1)">
                        <el-option v-for="(item,index) in pCode" :key="index" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品型号" class="h-elformWrap-2">
                    <el-select class="h-tableInput" filterable  v-model="saveData.productModel"disabled=""  >
                        <el-option v-for="(item,index) in pModel" :key="index" :label="item" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产地" class="h-elformWrap-2" required="">
                    <el-input class="h-tableInput" v-model="saveData.factory" disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="规格型号" class="h-elformWrap-2" required="">
                    <el-input placeholder="请输入..." class="h-tableInput" v-model="saveData.oemDesc" disabled="true"></el-input>
                </el-form-item>
                <!--<el-form-item label="型号属性" class="h-elformWrap-2" required="">-->
                <!--<el-input placeholder="请输入..." class="h-tableInput" v-model="saveData.protype" disabled=""></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="数量" class="h-elformWrap-2" required="">
                    <el-input v-model="saveData.proNumber" placeholder="产品数量" class="h-tableInput" disabled=""
                              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">
                    </el-input>
                </el-form-item>
                <el-form-item label="常规或改制" class="h-elformWrap-2" required="">
                    <brselect category="shifou_dingzhi" :v="saveData.isSpecific" disabled=""
                              v-model="saveData.isSpecific" placeholder="请选择"
                              @change="changes()" class="h-tableInput"/>
                </el-form-item>
                <el-form-item label="改制大类" class="h-elformWrap-2" required="" v-if="saveData.isSpecific == '2'">
                    <el-input v-if="saveData.isSpecific == 1" v-model="saveData.specific"
                              disabled=""
                              class="h-tableInput" placeholder="描述"></el-input>
                    <el-select v-else v-model="saveData.specific" placeholder="请选择"
                               style="width: 100%;" class="h-tableInput" @change="addspecificId()"
                               :multiple="true" disabled=""
                               clearable filterable>
                        <el-option v-for="(item,index) in describe" :key="item.specificId" :label="item.des"
                                   :value="item.des">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="改制要求" class="h-elformWrap-2" v-if="saveData.isSpecific == '2'">
                    <el-input v-model="saveData.specificReform"
                              disabled=""
                              placeholder="改制要求"
                              class="h-tableInput">
                    </el-input>
                </el-form-item>
                <el-form-item label="单台价加(元)" class="h-elformWrap-2" v-if="saveData.isSpecific == '2'">
                    <el-input placeholder="请输入..." v-model="saveData.reformPriceRmb" disabled=""></el-input>
                </el-form-item>
                <!--<el-form-item label="占用预排单类型" class="h-elformWrap-2" v-if="saveData.protype=='自产' && (saveData.isOther == '' || saveData.isOther == null)">-->
                    <!--<el-select class="h-tableInput" v-model="saveData.isScheduling" @change="isYp(2)" disabled="">-->
                        <!--<el-option value="" label=""></el-option>-->
                        <!--<el-option value="1" label="自己"></el-option>-->
                        <!--<el-option value="2" label="他人"></el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
                <el-form-item label="选择预排单号" class="h-elformWrap-2" v-if="saveData.protype=='自产' && (saveData.isOther == '' || saveData.isOther == null)">
                    <el-select v-model="saveData.ypIds" clearable placeholder="请选择" allow-create filterable
                               class="h-tableInput" :multiple="true" @change="getYbTable" disabled="">
                        <el-option v-for="(item, index) in getypData" :key="index" :label="item.id"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="预排数量" class="h-elformWrap-2" v-if="isYPdisabled">-->
                <!--<el-input v-model="saveData.ypNumber" placeholder="产品数量" class="h-tableInput"  @change="addNumber"-->
                <!--onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">-->
                <!--</el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="个人预测数量" class="h-elformWrap-2">-->
                <!--<el-input v-model="saveData.oneNumber" placeholder="产品数量" class="h-tableInput" @change="ypRelease"-->
                <!--onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">-->
                <!--</el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="占用预测单类型" class="h-elformWrap-2" v-if="saveData.isSpecific=='2' && (saveData.ypIds == '' || saveData.ypIds == null)">
                    <el-select class="h-tableInput" v-model="saveData.isOther" @change="isYp(1)" disabled="">
                        <el-option value="" label=""></el-option>
                        <el-option value="1" label="自己"></el-option>
                        <el-option value="2" label="他人"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="使用已预测单号" class="h-elformWrap-2" v-if="saveData.isOther=='1' && saveData.isSpecific=='2' && (saveData.ypIds == '' || saveData.ypIds == null)">
                    <el-select v-model="saveData.useData" clearable placeholder="请选择" allow-create filterable
                               class="h-tableInput" @change="addUseId()" :multiple="true" disabled="">
                        <el-option v-for="(item, index) in saveData.uids" :key="index" :label="item.code"
                                   :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="是否占用他人预测单号" class="h-elformWrap-2" required="">-->
                <!--<el-select class="h-tableInput" v-model="saveData.isOther" @change="isYp">-->
                <!--<el-option value="0" label="否"></el-option>-->
                <!--<el-option value="1" label="是"></el-option>-->
                <!--</el-select>-->
                <!--</el-form-item>-->
                <el-form-item label="使用他人已预测单号" class="h-elformWrap-2"  v-if="saveData.isOther=='2' && saveData.isSpecific=='2' && (saveData.isScheduling == '' || saveData.isScheduling == null)">
                    <el-select v-model="saveData.useOtherData" clearable placeholder="请选择" allow-create filterable
                               class="h-tableInput" @change="addUseIdOther()" :multiple="true" disabled="">
                        <el-option v-for="(item, index) in saveData.otherUseIds" :key="index" :label="item.code"
                                   :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="占用他人预测数量" class="h-elformWrap-2" required="" v-if="disabledOther && saveData.isSpecific=='2'">-->
                <!--<el-input v-model="saveData.otherNumber" placeholder="产品数量" class="h-tableInput"-->
                <!--onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">-->
                <!--</el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="改制类型" class="h-elformWrap-2" required=""  v-if="saveData.isSpecific=='2'">
                    <el-select class="h-tableInput" v-model="saveData.isReformStock" disabled="">
                        <el-option value="0" label="生产改制"></el-option>
                        <el-option value="1" label="库存改制"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="发货方式" class="h-elformWrap-2" required="" v-if="saveData.protype =='OEM'">
                    <el-select class="h-tableInput" v-model="saveData.deliveryMethod" disabled="">
                        <el-option value="1" label="直发"></el-option>
                        <el-option value="2" label="库发"></el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="船期日期" class="h-elformWrap-2">-->
                <!--<el-date-picker v-model="saveData.shippingDate" type="date" :clearable="false"-->
                <!--class="h-tableInput"-->
                <!--value-format="yyyy-MM-dd" :placeholder="saveData.shippingDate"-->
                <!--placeholder="请选择日期" :picker-options="pickerOptions">-->
                <!--</el-date-picker>-->
                <!--</el-form-item>-->
                <el-form-item label="是否实单" class="h-elformWrap-2" required="">
                    <el-select class="h-tableInput" v-model="saveData.isReal" disabled="">
                        <el-option value="1" label="实单"></el-option>
                        <el-option value="0" label="备货"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预计交货时间" class="h-elformWrap-2">
                    <el-date-picker v-model="saveData.deliveryDate" type="date" :clearable="false"
                                    class="h-tableInput" disabled=""
                                    value-format="yyyy-MM-dd" :placeholder="saveData.deliveryDate"
                                    placeholder="请选择日期" :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="备注" class="h-elformWrap-2">
                    <el-input v-model="saveData.remark" placeholder="备注" class="h-tableInput" disabled=""></el-input>
                </el-form-item>
                <el-form-item v-if="saveData.isLk == 1" prop="fileUrl" label="方案图纸" class="h-elformWrap-2"  :rules="this.lkFlag ?rules.fileUrl:[{ required: false, message: '请上传附件', trigger: 'blur' }]">
                    <brupload
                            v-model="fileUrl"
                            :refid=saveData.id
                            reftype="WXYC_LKFJ"
                            :limit="1"
                            :showtime="false"
                            delflag>
                    </brupload>
                </el-form-item>
                <el-form-item v-if="saveData.isLk == 1" prop="fileUrl" label="施工确认单" class="h-elformWrap-2"  :rules="this.lkFlag ?rules.fileUrl:[{ required: false, message: '请上传附件', trigger: 'blur' }]">
                    <brupload
                            v-model="fileUrl"
                            :refid=saveData.id
                            reftype="WXYC_SGQRD"
                            :limit="1"
                            :showtime="false"
                            delflag>
                    </brupload>
                </el-form-item>
                <el-form-item label="海尔标准配置" class="h-elformWrap-2" required="" v-if="saveData.isLk == 1">
                    <el-select class="h-tableInput" v-model="saveData.isStandard" disabled="">
                        <el-option value="1" label="是"></el-option>
                        <el-option value="2" label="否"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="saveData.receivingAddress != null && saveData.receivingAddress != ''" label="收货地址" class="h-elformWrap-2" prop="receivingAddress">
                  <el-input readonly v-model="saveData.receivingAddress"
                            :title="saveData.receivingAddress">
                  </el-input>
                </el-form-item>
                <el-form-item v-if="saveData.isLk == 1 " prop="fileUrl" label="投标参数" class="h-elformWrap-2"  :rules="this.lkFlag ?rules.fileUrl:[{ required: false, message: '请上传附件', trigger: 'blur' }]">
                    <brupload
                            v-model="fileUrl"
                            :refid=saveData.id
                            reftype="WXYC_TBCS"
                            :limit="1"
                            :showtime="false"
                            delflag>
                    </brupload>
                </el-form-item>
            </el-form>
        </div>
        <div v-if="ycTable.length > 0" style="width: 95%">
            <label style="margin-left: 2%">占用预测库存信息</label>
            <el-table
                    ref="multipleTable"
                    :data="ycTable"
                    stripe
                    border
                    max-height="500"
                    style="width: 100%;margin-left: 2%">
                <el-table-column
                        type="index"
                        width="40"
                        label="#">
                </el-table-column>
                <el-table-column
                        prop="id"
                        width="160"
                        :show-overflow-tooltip="true"
                        label="预测编码">
                </el-table-column>
                <el-table-column
                        prop="country"
                        width="90"
                        :show-overflow-tooltip="true"
                        label="国家名称">
                    <template slot-scope="scope">
                        <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proModel"
                        width="140"
                        :show-overflow-tooltip="true"
                        label="型号">
                </el-table-column>
                <el-table-column
                        prop="proCode"
                        width="120"
                        :show-overflow-tooltip="true"
                        label="产品编码">
                </el-table-column>
                <el-table-column
                        prop="protype"
                        width="90"
                        label="型号属性"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        width="60"
                        :show-overflow-tooltip="true"
                        label="数量">
                </el-table-column>
                <el-table-column
                        prop="useNumber"
                        :show-overflow-tooltip="true"
                        width="100"
                        label="可录单数量">
                </el-table-column>
                <el-table-column
                        prop="useInventory"
                        width="120"
                        :show-overflow-tooltip="true"
                        label="使用库存数量">
                </el-table-column>
                <el-table-column
                        prop="stockStatus"
                        width="90"
                        label="库存状态">
                    <template slot-scope="scope">
                        <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="isSpecific"
                        width="110"
                        :show-overflow-tooltip="true"
                        label="常规或改制">
                    <template slot-scope="scope">
                        <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                    </template>
                </el-table-column>
                <!--<el-table-column-->
                <!--prop="specificReq"-->
                <!--:show-overflow-tooltip="true"-->
                <!--min-width="180"-->
                <!--label="改制大类">-->
                <!--<template slot-scope="scope">-->
                <!--<div style="text-align: left;">{{scope.row.specificReq}}</div>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column
                        prop="specificReform"
                        :show-overflow-tooltip="true"
                        min-width="180"
                        label="改制要求">
                    <template slot-scope="scope">
                        <div style="text-align: left;">{{scope.row.specificReform}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="remark"
                        :show-overflow-tooltip="true"
                        min-width="180"
                        label="备注">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.remark}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="cuname"
                        width="90"
                        label="创建人">
                </el-table-column>
            </el-table>
        </div>
        <div v-if="OtherTable.length > 0" style="width: 95%">
            <label style="margin-left: 2%">占用他人预测库存信息</label>
            <el-table
                    ref="multipleTable"
                    :data="OtherTable"
                    stripe
                    border
                    max-height="500"
                    style="width: 100%;margin-left: 2%">
                <el-table-column
                        type="index"
                        width="40"
                        label="#">
                </el-table-column>
                <el-table-column
                        prop="id"
                        width="160"
                        :show-overflow-tooltip="true"
                        label="预测编码">
                </el-table-column>
                <el-table-column
                        prop="country"
                        width="90"
                        :show-overflow-tooltip="true"
                        label="国家名称">
                    <template slot-scope="scope">
                        <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proModel"
                        width="140"
                        :show-overflow-tooltip="true"
                        label="型号">
                </el-table-column>
                <el-table-column
                        prop="proCode"
                        width="120"
                        :show-overflow-tooltip="true"
                        label="产品编码">
                </el-table-column>
                <el-table-column
                        prop="protype"
                        width="90"
                        label="型号属性"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        width="60"
                        :show-overflow-tooltip="true"
                        label="数量">
                </el-table-column>
                <el-table-column
                        prop="useNumber"
                        :show-overflow-tooltip="true"
                        width="100"
                        label="可录单数量">
                </el-table-column>
                <el-table-column
                        prop="useInventory"
                        width="120"
                        :show-overflow-tooltip="true"
                        label="使用库存数量">
                </el-table-column>
                <el-table-column
                        prop="isSpecific"
                        width="110"
                        :show-overflow-tooltip="true"
                        label="常规或改制">
                    <template slot-scope="scope">
                        <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                    </template>
                </el-table-column>
                <!--<el-table-column-->
                <!--prop="specificReq"-->
                <!--:show-overflow-tooltip="true"-->
                <!--min-width="180"-->
                <!--label="改制大类">-->
                <!--<template slot-scope="scope">-->
                <!--<div style="text-align: left;">{{scope.row.specificReq}}</div>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column
                        prop="specificReform"
                        :show-overflow-tooltip="true"
                        min-width="180"
                        label="改制要求">
                    <template slot-scope="scope">
                        <div style="text-align: left;">{{scope.row.specificReform}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="remark"
                        :show-overflow-tooltip="true"
                        min-width="180"
                        label="备注">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.remark}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="stockStatus"
                        width="90"
                        label="库存状态">
                    <template slot-scope="scope">
                        <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="cuname"
                        width="90"
                        label="创建人">
                </el-table-column>
            </el-table>
        </div>
        <div v-if="ybTable.length > 0" style="width: 95%">
            <label style="margin-left: 2%">占用预排信息</label>
            <el-table
                    ref="multipleTable"
                    :data="ybTable"
                    stripep
                    border
                    max-height="500"
                    style="width: 100%;margin-left: 2%">
                <el-table-column
                        type="index"
                        width="40"
                        label="#">
                </el-table-column>
                <el-table-column
                        prop="id"
                        width="160"
                        :show-overflow-tooltip="true"
                        label="预测编码">
                </el-table-column>
                <el-table-column
                        prop="country"
                        width="90"
                        :show-overflow-tooltip="true"
                        label="国家名称">
                    <template slot-scope="scope">
                        <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proModel"
                        width="140"
                        :show-overflow-tooltip="true"
                        label="型号">
                </el-table-column>
                <el-table-column
                        prop="proCode"
                        width="160"
                        :show-overflow-tooltip="true"
                        label="产品编码">
                </el-table-column>
                <el-table-column
                        prop="protype"
                        width="90"
                        label="型号属性"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        width="60"
                        :show-overflow-tooltip="true"
                        label="数量">
                </el-table-column>
                <el-table-column
                        prop="useNumber"
                        :show-overflow-tooltip="true"
                        width="100"
                        label="剩余数量">
                </el-table-column>
                <el-table-column
                        prop="remark"
                        :show-overflow-tooltip="true"
                        min-width="180"
                        label="备注">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.remark}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="cuname"
                        label="创建人">
                </el-table-column>
            </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="dialogFormVisible = false">取 消</el-button>
            <!--<el-button class="h-btn h-bBtn h-bggreen" @click="submitFlage('暂存')">暂存</el-button>-->
            <!--<el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitFlage('提交')">确认提交</el-button>        -->
        </div>
    </el-dialog>
</template>

<script>
    import ss from '../../../../api/SystemService';
    export default {
        name: "wxxiangqingUpdate",
        props: {
        },
        data(){
            return{
                orderNumber:"",
                dialogFormVisible:false,
                submitData:[],
                describe: [
                    {
                        specificId: '1',
                        des: '更改电源线'
                    },
                    {
                        specificId: '2',
                        des: '更改铭牌'
                    },
                    {
                        specificId: '3',
                        des: '外箱加贴唛头等'
                    },
                    {
                        specificId: '4',
                        des: '更改说明书/售后手册/检测报告等'
                    },
                    {
                        specificId: '5',
                        des: '内销型号改外销'
                    },
                    {
                        specificId: '6',
                        des: '拆电池'
                    },
                    {
                        specificId: '7',
                        des: '冰排放水'
                    },
                    {
                        specificId: '8',
                        des: '更改外包装箱'
                    },
                    {
                        specificId: '9',
                        des: '增加USB'
                    },
                    {
                        specificId: '11',
                        des: '增加圆盘记录仪'
                    },
                    {
                        specificId: '0',
                        des: '目录外改制'
                    },
                    {
                        specificId: '12',
                        des: '电动门功能'
                    }
                ],
                ycTable:[],
                ycList:[],
                userRole: [],
                instid: '',
                showhistory: false,
                isYPdisabled:false,
                getypData:[],
                ybTable:[],
                disabledOther:false,
                getOtherData:[],
                OtherTable:[],
                ypDisabled:true,
                areaList:[],
                isCheck:false,
                saveData:{
                    area:null,
                    otherNumber:0,
                    ypNumber:0,
                    oneNumber:0,
                    otherUseIds:[],
                    useOtherData:[],
                    isOther:null,
                    isReal:null,
                    isScheduling:null,
                    ypIds:[],
                    preId:'',
                    deliveryMethod:'',
                    isReformStock:null,
                    // isShipDate:'',
                    // shippingDate:'',
                    proNumber:0,
                    proModel:'',
                    proCode:'',
                    country:'',
                    specificReform:'',
                    reformPriceRmb:'',
                    specific:[],
                    isSpecific:'',
                    protype:'',
                    remark:'',
                    deliveryDate:null,
                    codeOpt:[],
                    modelOpt:[],
                    uids:[],
                    useData:[],
                    isStandard: null,
                    factory:null,
                },
                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                gjCo:[],
                f: {
                    productModel: '',
                    productCode: ''
                },
                pModel: [],
                pCode: [],
                pCodecopy: [],
                items: {},
                disabled:true,
                fileUrl: [],
                rules:{
                    fileUrl: [
                        { required: true, message: '请上传冷库附件', trigger: 'blur' }
                    ]
                }
            }
        },
        created() {
            this.saveData.isOther = "";
            this.saveData.isScheduling = "";
        },
        methods:{
            addNumber(){
                this.saveData.proNumber = 0;
                var num = 0;
                if(this.ycTable.length>0){
                    for(var i=0;i<this.ycTable.length;i++){
                        num += parseInt(this.ycTable[i].useNumber);
                    }
                }
                if(!this.saveData.otherNumber || this.saveData.otherNumber==null){
                    this.saveData.otherNumber =0;
                }
                this.saveData.proNumber = parseInt(this.saveData.otherNumber)+num;
                this.$forceUpdate();
            },
            ypRelease(){
                if(this.saveData.oneNumber > this.saveData.ypNumber){
                    this.ypDisabled = false
                }else {
                    this.ypDisabled = true
                }
            },
            getYbTable(){
                this.ybTable = [];
                var obj= {
                    proCode: this.saveData.proCode
                }
                ss.waixiao.selectCheckPreList(obj).then(rd => {
                    for(var i=0;i<this.saveData.ypIds.length;i++){
                        for(var t=0;t<rd.length;t++){
                            if(this.saveData.ypIds[i]==rd[t].id){
                                this.ybTable.push(rd[t]);
                            }
                        }
                    }
                })
            },
            submitFlage(data){
                this.tableData = [];
                this.tableData.push(this.saveData);
                var f = true;
                b:
                    if (f) {
                        var cou = this.$store.getters.dictlist("YLCountry_agent");
                        for (var i = 0; i < this.tableData.length; i++) {
                            for (var j = 0; j < cou.length; j++) {
                                if (cou[j].name == this.tableData[i].country) {
                                    this.tableData[i].country = cou[j].code
                                }
                            }
                            if (this.tableData[i].isSpecific == 2) {
                                //循环设置
                                this.tableData[i].specificReq = _.join(this.tableData[i].specific || [], ",");
                            } else {
                                this.tableData[i].specificId = '';
                                this.tableData[i].specificReq = '';
                            }

                            if (this.tableData[i].useData && this.tableData[i].useData != '') {
                                this.tableData[i].useMeg = _.join(this.tableData[i].useData || [], ",");
                                this.tableData[i].useId = _.join(this.tableData[i].useData || [], ",");
                            } else {
                                this.tableData[i].useId = '';
                                this.tableData[i].useMeg = '';
                            }

                            this.tableData[i].prolist = [];
                            this.tableData[i].modelOpt = [];
                            this.tableData[i].codeOpt = [];
                            this.tableData[i].preId = '';
                            this.tableData[i].otherUseId = '';
                            if (this.tableData[i].ypIds) {
                                this.tableData[i].preId = _.join(this.tableData[i].ypIds || [], ",");
                            }
                            if (this.tableData[i].useOtherData) {
                                this.tableData[i].otherUseId = _.join(this.tableData[i].useOtherData || [], ",");
                            }
                            if (!this.tableData[i].specificType || this.tableData[i].specificType == '') {
                                if (this.tableData[i].isSpecific == 1) {
                                    this.tableData[i].specificType = '1';
                                } else {
                                    var index = this.tableData[i].specificId.indexOf("0");
                                    if (index == -1) {
                                        this.tableData[i].specificType = '1';
                                    } else {
                                        this.tableData[i].specificType = '2';
                                    }
                                }
                            }
                            // if (this.tableData[i].otherUseId || this.tableData[i].otherUseId != null || this.tableData[i].otherUseId != "") {
                            //     var num = 0;
                            //     for (var y = 0; y < this.OtherTable.length; y++) {
                            //         num += this.OtherTable[y].useNumber;
                            //     }
                            //     if (this.tableData[i].otherNumber > num) {
                            //         return this.$msg.msge("借用他人数量不能大于所选借用他人预测可录单数量");
                            //     }
                            // }
                            // console.log(this.tableData[i].specificType,"????");
                        }
                    }
                if(data == '提交'){
                    this.subTo();
                }else {
                    this.saveTo();
                }
            },
            saveTo() {
                ss.waixiao.saveTo(this.tableData).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.dialogFormVisible = false;
                    this.$parent.query();
                })
            },
            subTo() {
                this.$msg.confirm("确认提交?", () => {
                    this.submitData = this.tableData;
                    if (this.submitData.length == 0) {
                        this.$msg.msge("数据不能为空,请填写数据!");
                    } else {
                        var f = true;
                        b:
                            if (f) {
                                var cou = this.$store.getters.dictlist("YLCountry_agent");
                                for (var i = 0; i < this.submitData.length; i++) {
                                    for (var j = 0; j < cou.length; j++) {
                                        if (cou[j].name == this.submitData[i].country) {
                                            this.submitData[i].country = cou[j].code
                                        }
                                    }
                                    if (this.submitData[i].isSpecific == 2) {
                                        //循环设置
                                        this.submitData[i].specificReq = _.join(this.submitData[i].specific || [], ",");
                                    } else {
                                        this.submitData[i].specificId = '';
                                        this.submitData[i].specificReq = '';
                                    }
                                    // if(!this.submitData[i].useMeg || this.submitData[i].useMeg == '' || this.submitData[i].useMeg == null){
                                    //     this.$msg.msg("第"+(i+1)+"行，预测单未选择")
                                    //     return
                                    // }
                                    this.submitData[i].prolist = [];
                                    this.submitData[i].modelOpt = [];
                                    this.submitData[i].codeOpt = [];

                                    if (!this.submitData[i].specificType || this.submitData[i].specificType == '') {
                                        if (this.submitData[i].isSpecific == 1) {
                                            this.submitData[i].specificType = '1';
                                        } else {
                                            var index = this.submitData[i].specificId.indexOf("0");
                                            if(index == -1){
                                                this.submitData[i].specificType = '1';
                                            }else{
                                                this.submitData[i].specificType = '2';
                                            }
                                        }
                                    }
                                    if(!this.submitData[i].country || this.submitData[i].country == '' || this.submitData[i].country == null){
                                        return this.$msg.msge("国家不能为空");
                                    }
                                    if(!this.submitData[i].area || this.submitData[i].area == '' || this.submitData[i].area == null){
                                        return this.$msg.msge("区域不能为空");
                                    }
                                    if(!this.submitData[i].proCode || this.submitData[i].proCode == '' || this.submitData[i].proCode == null){
                                        return this.$msg.msge("产品编码不能为空");
                                    }
                                    if(!this.submitData[i].proNumber || this.submitData[i].proNumber == '' || this.submitData[i].proNumber == null){
                                        return this.$msg.msge("数量不能为空");
                                    }
                                    if(!this.submitData[i].isSpecific || this.submitData[i].isSpecific == '' || this.submitData[i].isSpecific == null){
                                        return this.$msg.msge("常规或改制不能为空");
                                    }
                                    if(this.submitData[i].isSpecific == '2' || this.submitData[i].isSpecific == 2){
                                        if(!this.submitData[i].isReformStock || this.submitData[i].isReformStock == '' || this.submitData[i].isReformStock == null){
                                            return this.$msg.msge("改制类型不能为空");
                                        }
                                    }
                                    if(!this.submitData[i].isReal || this.submitData[i].isReal == '' || this.submitData[i].isReal == null){
                                        return this.$msg.msge("是否实单不能为空");
                                    }
                                    if(this.submitData[i].isReal == '1'){
                                        if(!this.submitData[i].deliveryDate || this.submitData[i].deliveryDate == '' || this.submitData[i].deliveryDate == null){
                                            return this.$msg.msge("预计交货时间不能为空");
                                        }
                                    }
                                    if(this.submitData[i].isScheduling == '1' || this.submitData[i].isScheduling == '2'){
                                        if(!this.submitData[i].ypIds || this.submitData[i].ypIds == '' || this.submitData[i].ypIds == null){
                                            return this.$msg.msge("预排单号不能为空");
                                        }
                                    }
                                    if(this.submitData[i].isOther == '1'){
                                        if(!this.submitData[i].useData || this.submitData[i].useData == '' || this.submitData[i].useData == null){
                                            return this.$msg.msge("预测单号不能为空");
                                        }
                                    }else if(this.submitData[i].isOther == '2'){
                                        if(!this.submitData[i].useOtherData || this.submitData[i].useOtherData == '' || this.submitData[i].useOtherData == null){
                                            return this.$msg.msge("他人预测单号不能为空");
                                        }
                                    }
                                    if(this.submitData[i].protype == 'OEM') {
                                        if(!this.submitData[i].deliveryMethod || this.submitData[i].deliveryMethod == '' || this.submitData[i].deliveryMethod == null){
                                            return this.$msg.msge("发货方式不能为空");
                                        }
                                    }
                                }
                                ////ss.waixiao.subTo(this.submitData).then(rd => {
                                //// 新版提交
                                ss.waixiao.submitNewTo(this.submitData).then(rd => {
                                    this.$msg.msgs(rd.msg);
                                    this.submitData = [];
                                    this.dialogFormVisible = false;
                                    this.$parent.query();
                                });
                            }
                    }
                })
            },
            addspecificId(v) {
                this.saveData.specificId = '';
                this.saveData.reformPriceRmb = '';
                if(this.saveData.specific){
                    for (var i = 0; i < this.saveData.specific.length; i++) {
                        for (var j = 0; j < this.describe.length; j++) {
                            if (this.saveData.specific[i] == this.describe[j].des) {
                                if (this.describe[j].specificId && this.describe[j].specificId != '') {
                                    if (this.saveData.specificId != null && this.saveData.specificId != '') {
                                        this.saveData.specificId = this.saveData.specificId + this.describe[j].specificId + ", "
                                    } else {
                                        this.saveData.specificId = this.describe[j].specificId + ", "
                                    }
                                }
                                if (this.describe[j].specificId == '9') {
                                    if (this.saveData.reformPriceRmb != null && this.saveData.reformPriceRmb != '') {
                                        this.saveData.reformPriceRmb = this.saveData.reformPriceRmb + 335;
                                    } else {
                                        this.saveData.reformPriceRmb = 335;
                                    }
                                } else if (this.describe[j].specificId == '11') {
                                    if (this.saveData.reformPriceRmb != null && this.saveData.reformPriceRmb != '') {
                                        this.saveData.reformPriceRmb = this.saveData.reformPriceRmb + 2010;
                                    } else {
                                        this.saveData.reformPriceRmb = 2010;
                                    }
                                } else if (this.describe[j].specificId == '12') {
                                    if (this.saveData.reformPriceRmb != null && this.saveData.reformPriceRmb != '') {
                                        this.saveData.reformPriceRmb = this.saveData.reformPriceRmb + 5440;
                                    } else {
                                        this.saveData.reformPriceRmb = 5440;
                                    }
                                } else {
                                    if (this.saveData.reformPriceRmb != null && this.saveData.reformPriceRmb != '') {
                                        this.saveData.reformPriceRmb = this.saveData.reformPriceRmb + 0;
                                    } else {
                                        this.saveData.reformPriceRmb = 0;
                                    }
                                }
                            }
                        }
                    }
                    if(this.saveData.specificId){
                        var index = this.saveData.specificId.indexOf("0");
                    }
                    if(index == -1){
                        this.saveData.flag = true;
                        this.saveData.specificType = '1';
                    }else{
                        this.saveData.flag = false;
                        this.saveData.specificType = '2';
                    }
                }
                this.$forceUpdate()
            },
            changes(v) {
                if (this.saveData.isSpecific == 1) {
                    this.saveData.specific = '';
                    this.saveData.specificReq = '';
                    this.saveData.specificId = '';
                    this.saveData.specificType = '1';
                    this.saveData.specificReform = '';
                    this.saveData.reformPriceRmb = '';
                    this.disabledOther = false;
                    this.saveData.isOther = null;
                    this.saveData.otherNumber = 0;
                    this.saveData.useOtherData = [];
                    this.OtherTable = [];
                    this.saveData.useData = [];
                    this.saveData.useMeg = null;
                    this.ycTable = [];
                    this.saveData.isReformStock = null
                }else {
                    this.isYPdisabled = false;
                    this.saveData.isScheduling = null;
                    this.saveData.ypIds = null;
                    this.saveData.preId = null;
                    this.ybTable = [];
                }
                this.$forceUpdate();
            },
            addUseId(v) {
                // console.log("预测，",this.saveData.useData)
                this.saveData.useId='';
                this.ycTable = [];
                var list = [];
                var obj= {
                    proCode: this.saveData.proCode
                }
                ss.waixiao.checkSelectStock(obj).then(rd => {
                    list = rd;
                    if (this.saveData.useData && this.saveData.useData.length != 0 && this.saveData.uids && this.saveData.uids.length != 0) {
                        for (var i = 0; i < this.saveData.useData.length; i++) {
                            for (var j = 0; j < this.saveData.uids.length; j++) {
                                if (this.saveData.useData[i] == this.saveData.uids[j].name) {
                                    if (this.saveData.useId != null && this.saveData.useId != '') {
                                        this.saveData.useId = this.saveData.useId + this.saveData.uids[j].code + ","
                                    } else {
                                        this.saveData.useId = this.saveData.uids[j].code + ","
                                    }
                                }
                            }
                            for(var t=0;t<list.length;t++){
                                if(list[t].id == this.saveData.useData[i]){
                                    this.ycTable.push(list[t]);
                                }
                            }
                        }
                    }
                    this.$forceUpdate();
                })
            },
            addUseIdOther(v) {
                // console.log("预测，",this.saveData.useData)
                this.saveData.otherUseId='';
                this.OtherTable = [];
                var list = [];
                var obj= {
                    proCode: this.saveData.proCode
                }
                ss.waixiao.checkSelectStockOther(obj).then(rd => {
                    list = rd;
                    if (this.saveData.useOtherData && this.saveData.useOtherData.length != 0 && this.saveData.otherUseIds && this.saveData.otherUseIds.length != 0) {
                        if(this.saveData.useOtherData.length > 1){
                            return this.$msg.msge("只能选择一个他人预测");
                        }
                        for (var i = 0; i < this.saveData.useOtherData.length; i++) {
                            for (var j = 0; j < this.saveData.otherUseIds.length; j++) {
                                if (this.saveData.useOtherData[i] == this.saveData.otherUseIds[j].name) {
                                    if (this.saveData.otherUseId != null && this.saveData.otherUseId != '') {
                                        this.saveData.otherUseId = this.saveData.otherUseId + this.saveData.otherUseIds[j].code + ","
                                    } else {
                                        this.saveData.otherUseId = this.saveData.otherUseIds[j].code + ","
                                    }
                                }
                            }
                            for(var t=0;t<list.length;t++){
                                if(list[t].id == this.saveData.useOtherData[i]){
                                    this.OtherTable.push(list[t]);
                                }
                            }
                        }
                    }
                    this.$forceUpdate()
                })
            },
            decide() {
                if (this.saveData.productModel != this.items.proModel && this.saveData.productCode != this.items.proCode) {
                    this.items.proModel = this.saveData.productModel;
                    this.items.proCode = this.saveData.productCode;
                    this.items.describe = [];
                    this.items.specificReq = [];
                    this.items.uids = [];
                    this.items.useData = [];
                    this.items.specific = [];
                    this.items.specificReform = '';
                    this.items.reformPriceRmb = '';
                }
                ss.waixiao.selectProType(this.items.proCode, 2).then(rd => {
                    this.saveData.protype = rd;
                    // if(rd = 'OEM'){
                    //     this.saveData.deliveryMethod = '2';
                    // }
                })
                // var form = {}
                // form.country = this.saveData.country;
                // form.proCode = this.saveData.productCode;
                // form.proModel = this.saveData.productModel;
                // this.getYPlist(form);
                // this.selectDingzhi(this.items);
                this.selectStock(this.items);
                this.selectStockOther(this.items);
            },
            getYPlist(data){
                this.saveData.ypIds = [];
                if(this.saveData.preId && this.saveData.preId !=null){
                    this.saveData.ypIds = this.saveData.preId.split(",");
                }
                this.getypData=[];
                ss.waixiao.selectPreList(data).then(rd => {
                    this.getypData = rd;
                    this.getYbTable();
                })
            },
            getOtherYPlist(data){
                this.ybTable = [];
                this.saveData.ypIds = [];
                if(this.saveData.preId && this.saveData.preId !=null){
                    this.saveData.ypIds = this.saveData.preId.split(",");
                }
                this.getypData=[];
                ss.waixiao.selectOtherPreList(data).then(rd => {
                    this.getypData = rd;
                    this.getYbTable();
                })
            },
            selectStock(v) {
                this.ycList = [];
                this.saveData.uids = [];
                var obj= {
                    proCode: this.saveData.proCode
                }
                ss.waixiao.selectStock(obj).then(rd => {
                    if (rd && rd.length > 0) {
                        this.ycList = rd;
                        for (var i = 0; i < rd.length; i++) {
                            this.saveData.uids.push({
                                code: rd[i].id,
                                name: rd[i].strDes,
                            });
                        }
                    }
                    if(this.saveData.useMeg == "" || this.saveData.useMeg == null || !this.saveData.useMeg){
                        this.saveData.useData = [];
                    }else {
                        this.saveData.useData = this.saveData.useMeg.split(",");
                    }
                    this.addUseId();

                })
            },
            selectStockOther(v) {
                this.saveData.otherUseIds = [];
                this.getOtherData=[];
                var obj= {
                    proCode: this.saveData.proCode
                }
                if(this.isCheck){
                  ss.waixiao.selectStockOtherIsCheck(obj).then(rd => {
                    if (rd && rd.length > 0) {
                      this.getOtherData = rd;
                      for (var i = 0; i < rd.length; i++) {
                        this.saveData.otherUseIds.push({
                          code: rd[i].id,
                          name: rd[i].strDes,
                        });
                      }
                      if(this.saveData.otherUseId == "" || this.saveData.otherUseId == null || !this.saveData.otherUseId){
                        this.saveData.useOtherData = [];
                      }else {
                        this.saveData.useOtherData = this.saveData.otherUseId.split(",");
                      }
                      this.addUseIdOther();
                    }
                  })
                }else {
                  ss.waixiao.selectStockOther(obj).then(rd => {
                    if (rd && rd.length > 0) {
                      this.getOtherData = rd;
                      for (var i = 0; i < rd.length; i++) {
                        this.saveData.otherUseIds.push({
                          code: rd[i].id,
                          name: rd[i].strDes,
                        });
                      }
                      if(this.saveData.otherUseId == "" || this.saveData.otherUseId == null || !this.saveData.otherUseId){
                        this.saveData.useOtherData = [];
                      }else {
                        this.saveData.useOtherData = this.saveData.otherUseId.split(",");
                      }
                      this.addUseIdOther();
                    }
                  })
                }
            },
            isYp(a){
                var form = {}
                form.country = this.saveData.country;
                form.proCode = this.saveData.productCode;
                form.proModel = this.saveData.productModel;
                if(a == 2 || a == '2'){
                    this.saveData.preId = null;
                }
                // if(this.saveData.isScheduling && this.saveData.isScheduling =='1' && a != 1){
                //     this.getYPlist(form)
                // }else if (this.saveData.isScheduling && this.saveData.isScheduling =='2' && a != 1){
                //     this.getOtherYPlist(form)
                // }
                if(this.saveData.isOther && this.saveData.isOther == '1' && a == 1){
                    this.saveData.useOtherData = [];
                    this.OtherTable = [];
                }else if (this.saveData.isOther && this.saveData.isOther == '2' && a == 1){
                    this.saveData.useData = [];
                    this.ycTable = [];
                }else {
                    this.saveData.useData = [];
                    this.ycTable = [];
                    this.saveData.useOtherData = [];
                    this.OtherTable = [];
                    this.getYPlist(form)
                }
                if(a != 1 || a != '1'){
                    this.selectCode();
                }
            },
            dataFilter(val){
                val = val.replace(/\s*/g, "");
                this.productCode = val;
                if (val) { //val存在
                    this.pCode = this.pCodecopy.filter((item) => {
                        if (!!~item.indexOf(val) || !!~item.toUpperCase().indexOf(val.toUpperCase())) {
                            return true
                        }
                    })
                } else { //val为空时，还原数组
                    this.pCode = this.pCodecopy;
                }
            },
            selectCode(v) {
                for (var key in this.items.prolist) {
                    if (this.saveData.productCode == key) {
                        this.saveData.productModel = this.items.prolist[key];
                    }
                }

                if(v == 1){
                    this.ybTable = [];
                    this.getypData=[];
                    this.ycList = [];
                    this.saveData.uids = [];
                    this.saveData.useData = [];
                    this.saveData.useMeg = ''
                    this.ycTable = [];
                    this.OtherTable = [];
                    this.saveData.ypIds = [];
                    this.saveData.otherUseIds = [];
                    this.getOtherData=[];
                    this.saveData.useOtherData = [];
                }
                this.decide();

            },
            clickmodel1() {
                this.saveData.isReformStock = null;
                // this.saveData.isShipDate = '';
                // this.saveData.shippingDate = '';
                this.saveData.proModel = '';
                this.saveData.proCode = '';
                this.saveData.protype = '';
                this.saveData.proNumber = 0;
                this.saveData.useId = '';
                this.saveData.useMeg = '';
                this.saveData.isSpecific = '';
                this.saveData.specificReform = '';
                this.saveData.specificReq = '';
                this.saveData.specific = '';
                this.saveData.reformPriceRmb = '';
                this.saveData.specificType = '1';
                this.saveData.useData = [];
                this.saveData.uids = [];
                this.saveData.prolist = [];
                this.saveData.modelOpt = [];
                this.saveData.codeOpt = [];
                this.saveData.remark = '';
                this.saveData.deliveryDate = null;
                if (this.saveData.country && this.saveData.country != '') {
                    this.f.productModel = this.saveData.proModel;
                    this.f.productCode = this.saveData.proCode;
                    this.items = this.saveData;
                    if (this.saveData.codeOpt.length == 0 || this.saveData.modelOpt.length == 0) {
                        var guojia = '';
                        var guoj = this.$store.getters.dictlist("YLCountry_agent");
                        for (var i = 0; i < guoj.length; i++) {
                            if (guoj[i].name == this.saveData.country) {
                                guojia = guoj[i].code;
                            }
                        }
                        if (!guojia || guojia == '') {
                            guojia = this.saveData.country;
                        }
                        var m = {
                            country: guojia
                        }
                        ss.waixiao.showProduct(m).then(rd => {
                            this.saveData.prolist = rd;
                            for (var key in rd) {
                                this.saveData.modelOpt.push(rd[key]);
                                this.saveData.codeOpt.push(key);
                            }
                            this.pModel = this.saveData.modelOpt;
                            this.pCode = this.saveData.codeOpt;
                            this.pCodecopy = this.saveData.codeOpt;
                            this.disabled = false;
                        })
                    } else {
                        this.pModel = this.saveData.modelOpt;
                        this.pCode = this.saveData.codeOpt;
                        this.pCodecopy = this.saveData.codeOpt;
                        this.disabled = false;
                    }
                } else {
                    this.$msg.msge("请先选择国家！");
                }
            },
            clickmodel(data) {
                this.saveData= data;
                // if(data.otherNumber>0){
                //     this.saveData.otherNumber=data.otherNumber;
                // }else {
                //     this.saveData.otherNumber='';
                // }
                // if(data.oneNumber>0){
                //     this.saveData.oneNumber=data.oneNumber;
                // }else {
                //     this.saveData.oneNumber='';
                // }
                // if(data.ypNumber>0){
                //     this.saveData.ypNumber=data.ypNumber;
                // }else {
                //     this.saveData.ypNumber='';
                // }
                // this.saveData.deliveryMethod= data.deliveryMethod.toString();
                if(this.saveData.deliveryMethod || this.saveData.deliveryMethod==0){
                    this.saveData.deliveryMethod = this.saveData.deliveryMethod.toString()
                }
                if(this.saveData.isScheduling || this.saveData.isScheduling==0){
                    this.saveData.isScheduling = this.saveData.isScheduling.toString()
                }
                if(this.saveData.isOther || this.saveData.isOther==0){
                    this.saveData.isOther = this.saveData.isOther.toString()
                }
                if(this.saveData.isReal || this.saveData.isReal==0){
                    this.saveData.isReal = this.saveData.isReal.toString()
                }
                if(this.saveData.isStandard || this.saveData.isStandard==1 || this.saveData.isStandard==2){
                    this.saveData.isStandard = this.saveData.isStandard.toString()
                }
                this.saveData.productCode =  this.saveData.proCode;
                this.saveData.productModel =  this.saveData.proModel;
                this.saveData.otherUseIds=[];
                this.saveData.modelOpt = [];
                this.saveData.codeOpt = [];
                this.saveData.uids = [];
                this.saveData.useData = [];
                this.saveData.ypIds = [];
                if(this.saveData.otherUseId && this.saveData.otherUseId.length > 3){
                    this.saveData.useOtherData = this.saveData.otherUseId.split(",");
                }
                if(this.saveData.specificReq && this.saveData.specificReq.length > 3){
                    this.saveData.specific = this.saveData.specificReq.split(",");
                }
                if (this.saveData.country && this.saveData.country != '') {
                    this.f.productModel = this.saveData.proModel;
                    this.f.productCode = this.saveData.proCode;
                    this.items = this.saveData;
                    if (this.saveData.codeOpt.length == 0 || this.saveData.modelOpt.length == 0) {
                        var guojia = '';
                        var guoj = this.$store.getters.dictlist("YLCountry_agent");
                        for (var i = 0; i < guoj.length; i++) {
                            if (guoj[i].name == this.saveData.country) {
                                guojia = guoj[i].code;
                            }
                        }
                        if (!guojia || guojia == '') {
                            guojia = this.saveData.country;
                        }
                        var m = {
                            country: guojia
                        }
                        ss.waixiao.showProduct(m).then(rd => {
                            this.saveData.prolist = rd;
                            for (var key in rd) {
                                this.saveData.modelOpt.push(key);
                                this.saveData.codeOpt.push(rd[key]);
                            }
                            this.pModel = this.saveData.modelOpt;
                            this.pCode = this.saveData.codeOpt;
                            this.pCodecopy = this.saveData.codeOpt;
                            this.disabled = false;
                        })
                    } else {
                        this.pModel = this.saveData.modelOpt;
                        this.pCode = this.saveData.codeOpt;
                        this.pCodecopy = this.saveData.codeOpt;
                        this.disabled = false;
                    }
                    this.addspecificId();
                    this.isYp();
                }
            },
            showCountry(data) {
                var country = this.$store.getters.dictlist("YLCountry_agent");
                ss.waixiao.selectCountry().then(rd => {
                    for (var i = 0; i < rd.length; i++) {
                        for (var j = 0; j < country.length; j++) {
                            if (country[j].code == rd[i]) {
                                this.gjCo.push(country[j].name);
                            }
                            if(country[j].code == data.country){
                                data.country = country[j].name;
                            }
                        }
                    }
                    this.clickmodel(data)
                })
            },
            showArea() {
                ss.waixiao.getArea().then(rd => {
                    this.areaList = rd;
                    // this.saveData.area = rd[0].qycode;
                })
            },
            isShowDia(parentToChildData,isVastus){
                let self = this
                self.dialogFormVisible =isVastus;
                this.gjCo = [];
                this.query(parentToChildData)

            },
            query(data) {
                let form = {};
                form.id = data.id
                ss.waixiao.showPage(form).then(rd => {
                    this.showCountry(rd.records[0]);
                    this.showArea();
                    if(rd != null){
                      this.isCheck = true;
                    }
                })
            },
        }
    }
</script>

<style scoped>

    .h-dialog2{

    }
    .h-dialog2 .h-dialogImg {
        height: 1.62rem;
        background:#007fd8 url(/img/h-dialogImg.471fa846.png) left no-repeat;
        background-size: 7.89rem;
        padding-left: 4.02rem;
    }
    .h-dialog2 /deep/.el-dialog{
        width: 14rem ;
        margin: 0 auto;
    }
    .h-dialog2 .el-dialog__body{
        padding: 1rem 0;
    }
    .h-dialogForm{
        padding:0.25rem 0 0 0
    }
    .h-dialogForm .h-elformWrap-2{
        width:30%;
        margin-right: 3%
    }
    .h-dialog2 /deep/.el-dialog__footer{
        padding-bottom: .2rem
    }

</style>
